import React from "react";
import { twMerge } from "tailwind-merge";

const sizeVariants = {
  xs: "text-base md:text-lg font-semibold",
  sm: "text-lg md:text-xl font-semibold",
  md: "text-xl md:text-2xl font-semibold",
  lg: "text-2xl md:text-3xl font-semibold",
  xl: "text-3xl md:text-4xl font-semibold",
} as const;

const heightVariants = {
  page: "h-16 leading-[62px]",
} as const;

export type HeadingSize = keyof typeof sizeVariants;
export type HeadingHeight = keyof typeof heightVariants;

/**
 * Heading
 *
 * Typography component for page/section headings with size and height options.
 */
export interface HeadingProps {
  tag?: React.ElementType;
  size?: HeadingSize;
  height?: HeadingHeight;
  className?: string;
  children?: React.ReactNode;
}

export function Heading({ tag: Tag = "h1", size = "lg", height, className = "", children }: HeadingProps) {
  const sizeClasses = sizeVariants[size];
  const heightClasses = height ? heightVariants[height] : "";

  return <Tag className={twMerge(sizeClasses, heightClasses, className)}>{children}</Tag>;
}
